var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 31,
    rx: 2.5,
    fill: "#FAFAFA",
    stroke: "#B3B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7528 9.18541L13.2 11.85C13.0741 11.9444 13 12.0926 13 12.25V22C13 22.412 13.4704 22.6472 13.8 22.4L16.7528 20.1854C16.9043 20.0718 17.107 20.0535 17.2764 20.1382L22.7236 22.8618C22.893 22.9465 23.0957 22.9282 23.2472 22.8146L26.8 20.15C26.9259 20.0556 27 19.9074 27 19.75V10C27 9.58798 26.5296 9.35279 26.2 9.6L23.2472 11.8146C23.0957 11.9282 22.893 11.9465 22.7236 11.8618L17.2764 9.1382C17.107 9.0535 16.9043 9.07178 16.7528 9.18541Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9V20",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12V23",
    stroke: "#333333",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/map.93f7fa4ee3c7f26dfe4af6fe98459d88.svg";